"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const F = createSVGIcon(
  <path
    d="M10.75 2.567 9.676 0H.892v.153q.427.06.695.137.27.062.506.306.094.091.142.305.063.2.079.459.032.26.032.55.015.29.015.565V6.34q0 .458-.015.902 0 .428-.016.794v.58q0 .246-.016.505-.016.244-.063.473-.032.229-.08.413a.7.7 0 0 1-.126.26q-.221.244-.568.382a3.2 3.2 0 0 1-.727.198V11h5.055v-.153q-.647-.03-.995-.137-.332-.123-.474-.336-.142-.215-.19-.642A24 24 0 0 1 4.1 8.8q0-.26-.016-.611V5.5h.759q.158 0 .331.015.174 0 .411.016.459.03.79.168a2 2 0 0 1 .648.382q.33.29.568.84.238.535.364 1.023h.19V3.025h-.19q-.063.382-.142.718a1.8 1.8 0 0 1-.269.596q-.19.275-.521.473-.332.2-.9.321-.222.045-.554.077l-.647.03q-.3.015-.553.016h-.285V2.612q.015-.641.032-1.176a17 17 0 0 1 .063-.78q.015-.12.032-.213A1 1 0 0 0 4.258.26h.237a4 4 0 0 1 .363-.016A5 5 0 0 1 5.252.23q.205-.015.364-.015.931 0 1.627.092.71.076.98.198.552.26 1.137.81t1.232 1.329z"
    fill="currentColor"
  />,
  "F",
  { viewBox: "0 0 11 11", className: legacyIconCls() }
);
